<template>
  <!-- Page Introduction Wrapper -->
  <div class="page-style-a">
    <div class="container">
      <div class="page-intro">
        <h2>Wishlist</h2>
        <ul class="bread-crumb">
          <li class="has-separator">
            <i class="ion ion-md-home"></i>
            <router-link :to="{name : 'Home'}">Home</router-link>
          </li>
          <li class="is-marked">
            <a href="wishlist.html">Wishlist</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- Page Introduction Wrapper /- -->
  <Wishlist />
  <Footer />
</template>

<script>
import Footer from "../components/Bottom/Footer.vue";
import Wishlist from "../components/Wishlist/Wishlist.vue";
export default {
  components: { Footer, Wishlist },
};
</script>

<style>
</style>